import React from 'react';
import PropTypes from 'prop-types';
import Amount from 'sharedWebpack/Amount';
import './styles.scss';

const OldFlightAccordionHeader = ({ priceDetails }) => {
  const { currency, amount } = priceDetails;

  return (
    <div className="d-flex align-center justify-between flex-grow flex-wrap">
      <div>
        <div>{I18n.t('components.ibe.exchange.cart.paid')}</div>
        <div className="old-flight-accordion-header__highlighted-text">
          {I18n.t('components.ibe.exchange.cart.excluded')}
        </div>
      </div>
      <Amount className="old-flight-accordion-header__amount" currency={currency} value={amount} />
    </div>
  );
};

OldFlightAccordionHeader.propTypes = {
  priceDetails: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
  }).isRequired,
};

export default OldFlightAccordionHeader;
